import styled from 'styled-components';
import { Box } from '@scope/scope-one-ui/core';
import { COLORS } from '@scope/scope-one-ui/theme';
import { SIZES } from '@scope/scope-one-ui/theme';

export const ChartBox = styled(Box)`
  border-right: 1px solid ${COLORS.border.main};
`;

export const VerticalTitle = styled(Box)`
  width: 100%;
`;

export const HorizontalTitles = styled(Box)`
  width: 100%;
  position: absolute;
  top: ${SIZES.spacing(29)};
`;

export const ChartContainer = styled(Box)`
  position: relative;
`;
